import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { Button, CheckboxFieldReduxFormWrapper } from '@adc/ui-core'
import classNames from 'classnames/bind'
import {
  canAddChild,
  rulesType,
  getFormChildren,
  getChildInitialSubType,
} from '../utils'
import SubEntityForm from '../subEntityForm'
import styles from './styles.scss'
const cx = classNames.bind(styles)

const MultiSubEntity = ({
  fields,
  meta,
  level,
  entityType,
  showTitlesOnly = false,
  formKeyPrefix,
  interestedPartiesCount,
  isAutoCapitalize,
  isOhioAsset,
  contentOpenedContext,
  interestedParties,
  rules,
}) => {
  const onAddInterestedParty = e => {
    const { updateContentOpened } = contentOpenedContext
    // button clicks trigger form submit
    e.preventDefault()
    e.stopPropagation()
    const subFormType = getChildInitialSubType(level, rules)
    const includeSignature = true
    const entityNameText = `Interested Party ${interestedPartiesCount + 1}`
    const nameText = `Individual ${interestedPartiesCount + 1}`
    fields.push({
      subFormType,
      includeSignature,
      entityNameText,
      nameText,
    })

    const key = `${formKeyPrefix}interestedParties[${interestedPartiesCount}]`
    updateContentOpened(key, true, true)
  }

  const onSubEntityFormClose = (index, subFormKeyName) => {
    return () => {
      const { deleteKey } = contentOpenedContext
      deleteKey(subFormKeyName)
      fields.remove(index)
    }
  }

  const renderSubEntityForms = () => {
    if (fields.length < 0) {
      return null
    } else {
      return (
        <div className={cx('content')}>
          {fields.map((subFormKeyName, index, fields) => (
            <SubEntityForm
              onClose={onSubEntityFormClose(index, subFormKeyName)}
              key={index}
              fieldArraysIndex={index}
              forms={getFormChildren(level, rules)}
              formKey={subFormKeyName}
              fields={fields}
              interestedParties={interestedParties}
              meta={meta}
              entityType={entityType}
              rules={rules}
              level={level}
              showTitlesOnly={showTitlesOnly}
              isAutoCapitalize={isAutoCapitalize}
              isOhioAsset={isOhioAsset}
              contentOpenedContext={contentOpenedContext}
            />
          ))}
        </div>
      )
    }
  }

  const renderAddComponent = () => {
    const addMore = rules.flow[level].addMore
    const isIndividualChildType =
      addMore.childTypes.includes('Individual') &&
      addMore.childTypes.length === 1
    const elmIdType = isIndividualChildType ? 'individual' : 'interested_party'

    return addMore.type === 'button' ? (
      <div className={cx('add-button-field')}>
        <Button
          elmId={`add_${elmIdType}`}
          role='primary'
          isStretch
          onClick={onAddInterestedParty}
        >
          {addMore.text}
        </Button>
      </div>
    ) : (
      <a
        className={cx('add-link')}
        data-elm-id={`${formKeyPrefix}add_${elmIdType}`}
        role='primary'
        onClick={onAddInterestedParty}
      >
        {addMore.text}
      </a>
    )
  }

  const renderMaxCheckbox = () => {
    const addMore = rules.flow[level].addMore
    const isParent = formKeyPrefix === 'parent.'

    return (
      <div className={cx('add-more-checkbox', isParent && 'parent-level')}>
        <Field
          name={
            isParent
              ? `${formKeyPrefix}moreEntityInvolved`
              : `${formKeyPrefix}moreIndividualInvolved`
          }
          type='checkbox'
          elmId={`${formKeyPrefix}checkbox_more_entity_involved`}
          checkboxLabel={addMore.checkboxMaxText}
          component={CheckboxFieldReduxFormWrapper}
        />
      </div>
    )
  }

  const canAddAnotherChild = canAddChild(interestedPartiesCount, level, rules)

  return (
    <div>
      <div className={cx('root')}>
        {renderSubEntityForms()}
        {!showTitlesOnly && !canAddAnotherChild && renderMaxCheckbox()}
      </div>
      {!showTitlesOnly && canAddAnotherChild && renderAddComponent()}
    </div>
  )
}

MultiSubEntity.propTypes = {
  fields: PropTypes.any,
  meta: PropTypes.object,
  level: PropTypes.number,
  entityType: PropTypes.string,
  showTitlesOnly: PropTypes.bool,
  formKeyPrefix: PropTypes.string,
  interestedPartiesCount: PropTypes.number,
  isAutoCapitalize: PropTypes.bool,
  isOhioAsset: PropTypes.bool,
  contentOpenedContext: PropTypes.shape({
    contentOpened: PropTypes.object.isRequired,
    deleteKey: PropTypes.func.isRequired,
    updateContentOpened: PropTypes.func.isRequired,
  }).isRequired,
  ...rulesType,
}

export default MultiSubEntity
